import React from "react";

interface HomePlusIconProps {
    className?: string;
}

export const HomePlusIcon: React.FC<HomePlusIconProps> = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 32 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className={className}>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            />
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M28 7.5v3m0 0v3m0-3h3m-3 0h-3"
            />
        </svg>
    );
};
